module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-3-2c51f574b50449f97e717b05a36dbc24.png";